import {
  AfterContentChecked,
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/@order/dialogs/confirmation-dialog/confirmation-dialog.component';
import { WalletInfoDialogComponent } from 'src/@order/dialogs/wallet-info-dialog/wallet-info-dialog.component';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterContentChecked {
  showHeader: boolean = true;
  country: string;
  isDrawerOpen = false;
  // public walletAmount:BehaviorSubject<number>;

  isBusinessPartner: boolean = false;
  userName = JSON.parse(localStorage.getItem('authUser')).firstName;
  userImage = JSON.parse(localStorage.getItem('authUser')).photo;

  constructor(
    private _router: Router,
    private _matDialog: MatDialog,
    public _auth: AuthServiceLocal
  ) {
    this._router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        // console.log("val", val);
        this.showHeader = !!String(val).match('orders');
      }
    });
    this.country = localStorage.getItem('country');
  }
  ngAfterContentChecked(): void {
    if (localStorage.getItem('isBusinessPartner') == '1') {
      this.isBusinessPartner = true;
    } else {
      this.isBusinessPartner = false;
    }
  }

  ngOnInit(): void {
    // this.walletAmount = new BehaviorSubject(0);
    this._auth.getDashboardData();
    // this._auth.getDashboardData({}).subscribe((res:any) => {
    //   if(res.response == 1){
    //       this.walletAmount.next(res?.data?.balance || 0);
    //     }else{
    //         this.walletAmount.next(0);
    //     }
    // })

    console.log('userImage', this._auth.userProfileData.value);
  }

  dialogOpen() {
    if (localStorage.getItem('isWalletWelcomeShow') == '0') {
      const dialog = this._matDialog.open(WalletInfoDialogComponent, {
        panelClass: ['commonDialogWrapper'],
        backdropClass: 'dialogBackdrop',
        width: '580px',
      });
      dialog.afterClosed().subscribe((res) => {
        localStorage.setItem('isWalletWelcomeShow', '1');
      });
    } else {
      this._router.navigate(['/wallet-transaction']);
    }
  }

  userLogout() {
    const dialog = this._matDialog.open(ConfirmationDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '480px',
      data: {
        heading: 'Message!',
        headingColor: 'text-red',
        message: 'Are you sure you want to log out?',
        action: {
          ok: 'Logout',
          cancel: 'Cancel',
          align: 'end',
        },
      },
    });

    dialog.afterClosed().subscribe((res) => {
      if (res) this._auth.userLogout();
    });
  }

  ngOnDestroy() {
    // if (this._auth.walletAmount) {
    //   this._auth.walletAmount.unsubscribe();
    // }
  }
}
